<template>
  <div class="tab-content">
    <el-tabs :value="value" @input="(val) => $emit('input', val)" @tab-click="handleClick">
      <!-- detail -->
      <el-tab-pane :disabled="!projectPermission.viewDetail" :label="$t('project_tab_info_detail')" name="first">
        <el-card v-if="projectInfo" class="box-card card panel">
          <el-row class="info-title-color">
            <el-col :span="11">
              <div class="title">{{$t('project_tab_info_detail_project')}}</div>

              <el-row style="margin-bottom: 5px;">
                <el-col :span="8" class="h-center">
                  <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                  {{$t('project_tab_info_detail_createdBy')}}
                </el-col>
                <el-col :span="16" class="info-color">
                  <el-tooltip placement="top">
                    <div slot="content">
                      <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                      <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                      <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                      <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                      <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                      <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                      <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                      <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                    </div>
                    <span class="pointer" v-if="projectInfo.creatorUser" @mouseenter="getUserInfo(projectInfo.creatorUser.id)">{{projectInfo.creatorUser.user.fullName}}</span>
                  </el-tooltip>
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 5px;">
                <el-col :span="8" class="h-center">
                  <img src="@/assets/img/info/no.svg" width="20px;" style="margin-right: 5px;">
                  {{$t('project_tab_info_detail_projectNo')}}:
                </el-col>
                <el-col :span="16">
                  <el-row class="info-color">
                    <el-col :span="24">{{projectInfo.no}}</el-col>
                  </el-row>
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 5px;">
                <el-col :span="8" class="h-center">
                  <img src="@/assets/img/info/project_icn.svg" width="20px;" style="margin-right: 5px;">
                  {{$t('project_tab_info_detail_projectName')}}:
                </el-col>
                <el-col :span="16">
                  <el-row class="info-color">
                    <el-col :span="24">
                      <strong>{{projectInfo.name}}</strong>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 5px;">
                <el-col :span="8" class="h-center">
                  <img src="@/assets/img/info/case.svg" width="20px;" style="margin-right: 5px;">
                  <span>{{$t('modal_type')}}:</span>
                </el-col>
                <el-col :span="16" class="info-color">
                  {{projectInfo.type.name}}
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 5px;">
                <el-col :span="8" class="h-center">
                  <img src="@/assets/img/info/case.svg" width="20px;" style="margin-right: 5px;">
                  <span>{{$t('modal_region')}}:</span>
                </el-col>
                <el-col :span="16" class="info-color">
                  {{projectInfo.projectRegion.name}}
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 5px;">
                <el-col :span="8" class="h-center">
                  <img src="@/assets/img/info/case.svg" width="20px;" style="margin-right: 5px;">
                  <span>{{$t('modal_email')}}:</span>
                </el-col>
                <el-col :span="16" class="info-color">
                  {{projectInfo.projectEmail}}
                </el-col>
              </el-row>

              <el-row v-if="projectInfo.isAddressAssigned" style="margin-bottom: 5px;">
                <el-col :span="8" class="h-center">
                  <img src="@/assets/img/info/globe.svg" width="20px;" style="margin-right: 5px;">
                  <span>{{$t('modal_projectAddress')}}:</span>
                </el-col>
                <el-col :span="16" class="info-color">
                  <el-link @click="openMap()" type="primary">{{projectInfo.country.name + ', ' + projectInfo.state.name + ', ' + projectInfo.city.name + ', ' + projectInfo.address + ', ' + projectInfo.address2 + ', ' + projectInfo.address3}}</el-link>
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 5px;">
                <el-col :span="8" class="h-center">
                  <img src="@/assets/img/info/dollar-sign.svg" width="20px;" style="margin-right: 5px;">
                  <span>{{$t('modal_billingMethod')}}:</span>
                </el-col>
                <el-col :span="16" class="info-color">
                  <span v-if="projectInfo.bill == 0">{{$t('modal_billing_single')}}</span>
                  <span v-if="projectInfo.bill == 1">{{$t('modal_billing_progress')}}</span>
                  <span v-if="projectInfo.bill == 2">{{$t('modal_billing_notBillable')}}</span>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <div class="title">{{$t('project_tab_info_detail_dates')}}</div>

              <el-row style="margin-bottom: 5px;">
                <el-col :span="8" class="h-center">
                  <img src="@/assets/img/info/calendar_icn.svg" width="20px;" style="margin-right: 5px;">
                  {{$t('project_tab_info_detail_planned')}}
                </el-col>
                <el-col :span="16" class="info-color">
                  {{moment(projectInfo.startDate).format("D MMM YY, h:mm a")}}
                  {{$t('project_tab_info_detail_to')}}
                  {{moment(projectInfo.deadlineDate).format("D MMM YY, h:mm a")}}
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 5px;">
                <el-col :span="8" class="h-center">
                  <img src="@/assets/img/info/calendar_icn.svg" width="20px;" style="margin-right: 5px;">
                  <span v-if="projectInfo.startedDate && !projectInfo.endedDate">{{$t('project_tab_info_detail_actual_start_date')}}</span>
                  <span v-else>{{$t('project_tab_info_detail_actual')}}</span>
                </el-col>
                <el-col :span="16" class="info-color">
                  <span v-if="projectInfo.startedDate">{{moment(projectInfo.startedDate * 1000).format("D MMM YY")}}</span>
                  <span v-if="projectInfo.endedDate"> {{$t('project_tab_info_detail_to')}} {{moment(projectInfo.endedDate * 1000).format("D MMM YY")}}</span>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <div class="title">{{$t('project_tab_info_detail_bu')}}</div>

              <el-row style="margin-bottom: 5px;">
                <el-col :span="8" class="h-center">
                  <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                  <span>{{$t('modal_projectOwner')}}:</span>
                </el-col>
                <el-col :span="16" class="info-color">
                  {{projectInfo.projectOwner}}
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 5px;">
                <el-col :span="8" class="h-center">
                  <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                  {{$t('project_tab_info_detail_assignedTo')}}
                </el-col>
                <el-col :span="16" class="info-color">
                  <el-tooltip placement="top">
                    <div slot="content">
                      <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                      <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                      <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                      <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                      <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                      <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                      <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                      <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                    </div>
                    <span class="pointer" v-if="projectInfo.leaderUser" @mouseenter="getUserInfo(projectInfo.leaderUser.id)">{{projectInfo.leaderUser.user.fullName}}</span>
                  </el-tooltip>
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 5px;">
                <el-col :span="8" class="h-center">
                  <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                  <span>{{$t('modal_projectBU')}}:</span>
                </el-col>
                <el-col :span="16" class="info-color">
                  {{projectInfo.buNames}}
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 5px;">
                <el-col :span="8" class="h-center">
                  <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                  <span>{{$t('modal_BUManagers')}}:</span>
                </el-col>
                <el-col :span="16" class="info-color">
                  {{projectInfo.busManagers}}
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <div class="title">{{$t('project_tab_info_detail_notifications')}}</div>

              <el-row style="margin-bottom: 5px;">
                  <el-col :span="8" class="h-center">
                      <img src="@/assets/img/info/bell-checked.svg" width="20px;" style="margin-right: 5px;">
                      <span>{{$t('modal_BUManagersNotified')}}:</span>
                  </el-col>
                  <el-col :span="16" class="info-color">
                    <span v-if="projectInfo.projectNotifySettings.notifyTeam">{{$t('general_yes')}}</span>
                    <span v-else>{{$t('general_no')}}</span>
                  </el-col>
              </el-row>

              <el-row style="margin-bottom: 5px;">
                  <el-col :span="8" class="h-center">
                      <img src="@/assets/img/info/bell-checked.svg" width="20px;" style="margin-right: 5px;">
                      <span>{{$t('modal_clientsNotified')}}:</span>
                  </el-col>
                  <el-col :span="16" class="info-color">
                    <span v-if="projectInfo.projectNotifySettings.notifyClients">{{$t('general_yes')}}</span>
                    <span v-else>{{$t('general_no')}}</span>
                  </el-col>
              </el-row>

              <el-row style="margin-bottom: 5px;">
                  <el-col :span="8" class="h-center">
                      <img src="@/assets/img/info/bell-checked.svg" width="20px;" style="margin-right: 5px;">
                      <span>{{$t('modal_vendorsNotified')}}:</span>
                  </el-col>
                  <el-col :span="16" class="info-color">
                    <span v-if="projectInfo.projectNotifySettings.notifyVendors">{{$t('general_yes')}}</span>
                    <span v-else>{{$t('general_no')}}</span>
                  </el-col>
              </el-row>

              <el-row style="margin-bottom: 5px;">
                  <el-col :span="8" class="h-center">
                      <img src="@/assets/img/info/bell-checked.svg" width="20px;" style="margin-right: 5px;">
                      <span>{{$t('modal_partnersNotified')}}:</span>
                  </el-col>
                  <el-col :span="16" class="info-color">
                    <span v-if="projectInfo.projectNotifySettings.notifyPartners">{{$t('general_yes')}}</span>
                    <span v-else>{{$t('general_no')}}</span>
                  </el-col>
              </el-row>

              <el-divider></el-divider>

            </el-col>
            <el-col :span="13">
              <!-- <div class="title" style="text-align: center;">PROGRESS</div> -->

              <el-row type="flex" justify="end">
                <el-col :span="8">
                  <br>
                  <el-row>
                    <el-col :span="24" style="margin-bottom: 15px;">
                      <div style="margin-left: 45px;">Phase</div>
                      <el-tooltip class="item" effect="dark" content="Phase" placement="right">
                        <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="projectInfo.companyStage.name"></el-tag>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 15px;">
                      <div style="margin-left: 45px;">Status</div>
                      <el-tooltip class="item" effect="dark" content="Status" placement="right">
                        <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="$t(projectInfo.projectStatus.translationKey)"></el-tag>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="24">
                      <div style="margin-left: 45px;">Priority</div>
                      <el-tooltip class="item" effect="dark" content="Priority" placement="right">
                        <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="$t(projectInfo.priority.translationKey)"></el-tag>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <div class="title">{{$t('project_tab_info_detail_progress')}}</div>

                    <div style="margin-bottom: 15px;">
                        <!-- <div class="circle">
                            <div class="circle_number">{{projectInfo.doneChildTasksCount}}/{{projectInfo.childTasksCount}}</div>
                        </div> {{$t('general_done')}}/{{$t('general_subTask')}} -->

                        <!-- <el-row :gutter="0" style="margin-bottom: 0px;">
                          <el-col :span="7" :offset="0" style="text-align: right; padding-right: 7px;">{{$t('general_done')}}</el-col>
                          <el-col :span="2" :offset="0"> / </el-col>
                          <el-col :span="15" :offset="0">{{$t('general_subTask')}}</el-col>
                        </el-row>

                        <el-row :gutter="0">
                          <el-col :span="7" :offset="0" style="text-align: right; padding-right: 7px;">({{projectInfo.doneChildTasksCount}})</el-col>
                          <el-col :span="2" :offset="0"> / </el-col>
                          <el-col :span="15" :offset="0">({{projectInfo.childTasksCount}})</el-col>
                        </el-row> -->

                        <el-row :gutter="20">
                          <el-col :span="24" :offset="0">{{projectInfo.childTasksCount}} - {{$t('general_subTask')}}</el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="24" :offset="0">{{projectInfo.fullProgressTasksCount}} - 100%</el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="24" :offset="0">{{projectInfo.doneChildTasksCount}} - {{$t('general_done')}}</el-col>
                        </el-row>

                        <!-- <div>{{$t('general_done')}} ({{projectInfo.doneChildTasksCount}}) / {{$t('general_subTask')}} ({{projectInfo.childTasksCount}})</div> -->
                    </div>
                    <div>
                        <!-- <div class="circle">
                            <div class="circle_number">{{projectInfo.fullProgressTasksCount}}/{{projectInfo.childTasksCount}}</div>
                        </div> 100%/{{$t('general_subTask')}} -->

                        <!-- <el-row :gutter="0" style="margin-bottom: 0px;">
                          <el-col :span="7" :offset="0" style="text-align: right; padding-right: 7px;">100%</el-col>
                          <el-col :span="2" :offset="0"> / </el-col>
                          <el-col :span="15" :offset="0">{{$t('general_subTask')}}</el-col>
                        </el-row>

                        <el-row :gutter="0">
                          <el-col :span="7" :offset="0" style="text-align: right; padding-right: 7px;">({{projectInfo.fullProgressTasksCount}})</el-col>
                          <el-col :span="2" :offset="0"> / </el-col>
                          <el-col :span="15" :offset="0">({{projectInfo.childTasksCount}})</el-col>
                        </el-row> -->

                        <!-- <div>100% ({{projectInfo.fullProgressTasksCount}}) / {{$t('general_subTask')}} ({{projectInfo.childTasksCount}})</div> -->
                    </div>
                </el-col>
                <el-col :span="8">
                  <br>
                  <qr-code :text="'https://dev.totalflow.io' + this.$route.fullPath" :size="120"></qr-code>
                </el-col>
              </el-row>
            </el-col>
          </el-row>


          <div class="panel__footer">
            <div class="panel__first">

              <el-row :gutter="20">
                <el-col :span="14" :offset="0">
                  <div class="panel__team_title">
                    <i class="color h-center">
                      <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                      <div class="title">{{$t('project_tab_info_detail_managementTeam')}}:</div>
                      <!-- {{$t('project_tab_info_detail_managementTeam')}}: -->
                    </i>
                  </div>
                  <div>
                    <div  class="panel__team_item" v-for="item in projectCompanyUserList" :key="item.id">
                      <el-tooltip placement="top">
                        <div slot="content">
                          <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                          <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                          <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                          <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                          <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                          <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                          <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                          <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                        </div>
                        <span class="pointer" @mouseenter="getUserInfo(item.companyUserId)" v-html="item.userFullName"></span>
                      </el-tooltip>
                    </div>
                  </div>
                </el-col>
                <el-col :span="10" :offset="0">
                  <div class="title">{{$t('project_tab_info_detail_permissions')}}:</div>
                  <div class="panel__team_item" style="cursor: default;" v-for="item in projectCompanyUserList" :key="item.id">
                    <div>{{item.permissionPreset}}</div>
                  </div>
                </el-col>
              </el-row>

            </div>
            <div class="panel__second">
              <div class="panel__team_title">
                <i class="color h-center">
                  <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                  <div class="title">{{$t('project_tab_info_detail_projectPartners')}}:</div>
                  <!-- {{$t('project_tab_info_detail_projectPartners')}}: -->
                </i>
              </div>
            </div>
            <div class="panel__third">
              <div class="panel__team_title">
                <i class="color h-center">
                  <img src="@/assets/img/info/client_icn.svg" width="20px;" style="margin-right: 5px;">
                  <div class="title">{{$t('project_tab_info_detail_projectClients')}}:</div>
                  <!-- {{$t('project_tab_info_detail_projectClients')}}: -->
                </i>
              </div>
              <div>
                <div class="panel__team_item" v-for="item in projectCompanyClientList" :key="item.id">
                  <el-tooltip placement="top">
                    <div slot="content">
                      <span v-if="item.companyClient.name">Name: {{item.companyClient.name}}<br/></span>
                      <span v-if="item.companyClient.phone">Phone: {{item.companyClient.phone}}<br/></span>
                      <span v-if="item.companyClient.street">Location: {{item.companyClient.street}}<br/></span>
                      <span v-if="item.companyClient.email">Email: {{item.companyClient.email}}<br/></span>
                      <span v-if="item.companyClient.fax">Fax: {{item.companyClient.fax}}<br/></span>
                      <span v-if="item.companyClient.website">Website: <a :href="item.companyClient.website" target="_blank">{{item.companyClient.website}}</a><br/></span>
                      <span v-if="item.companyClient.facebook">Facebook: <a :href="item.companyClient.facebook" target="_blank">{{item.companyClient.facebook}}</a><br/></span>
                      <span v-if="item.companyClient.linkedin">Linkedin: <a :href="item.companyClient.linkedin" target="_blank">{{item.companyClient.linkedin}}</a><br/></span>
                    </div>
                    <span v-html="item.companyClient.name"></span>
                  </el-tooltip>
                </div>
              </div>

              <div class="panel__team_title" style="padding-top: 25px;">
                <i class="color h-center">
                  <img src="@/assets/img/info/vendor_icn.svg" width="20px;" style="margin-right: 5px;">
                  <div class="title">{{$t('project_tab_info_detail_projectVendors')}}:</div>
                  <!-- {{$t('project_tab_info_detail_projectVendors')}}: -->
                </i>
              </div>
              <div>
                <div class="panel__team_item" v-for="item in projectCompanyVendorList" :key="item.id">
                  <el-tooltip placement="top">
                    <div slot="content">
                      <span v-if="item.companyVendor.name">Name: {{item.companyVendor.name}}<br/></span>
                      <span v-if="item.companyVendor.phone">Phone: {{item.companyVendor.phone}}<br/></span>
                      <span v-if="item.companyVendor.street">Location: {{item.companyVendor.street}}<br/></span>
                      <span v-if="item.companyVendor.email">Email: {{item.companyVendor.email}}<br/></span>
                      <span v-if="item.companyVendor.fax">Fax: {{item.companyVendor.fax}}<br/></span>
                      <span v-if="item.companyVendor.website">Website: <a :href="item.companyVendor.website" target="_blank">{{item.companyVendor.website}}</a><br/></span>
                      <!-- <span v-if="item.companyVendor.facebook">Facebook: {{item.companyVendor.facebook}}<br/></span>
                      <span v-if="item.companyVendor.linkedin">Linkedin: {{item.companyVendor.linkedin}}<br/></span> -->
                    </div>
                    <span v-html="item.companyVendor.name"></span>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>

        </el-card>
      </el-tab-pane>

      <!-- about -->
      <el-tab-pane :disabled="!projectPermission.viewAbout" :label="$t('project_tab_info_about')" name="about">
        <el-card class="box-card card panel">
          <!-- <div v-html="!projectInfo.description ? emtyDescription : projectInfo.description"></div> -->
          <about/>
        </el-card>
        <!-- (About project) -->
      </el-tab-pane>

      <!-- to do -->
      <!-- <el-tab-pane :disabled="!projectPermission.viewToDo" :label="$t('project_tab_info_toDo')" name="toDo">
        <el-card class="box-card card panel">
          Current Service Under Development
        </el-card>
      </el-tab-pane> -->

      <!-- history -->
      <el-tab-pane :disabled="!projectPermission.viewHistory" :label="$t('project_tab_info_history')" name="five">
        <projectHistory/>
      </el-tab-pane>

      <el-tab-pane v-if="companyLayout.permission.managePermissionProject" :label="$t('project_tab_info_permissions')" name="permissions">
        <projectPermissionTab @setNewPermissions="setNewPermissions" ref="projectPermissionTab" :permissionsList="permissionsList" :pressetsList="pressetsList"/>
      </el-tab-pane>

    </el-tabs>

    <!-- [ Modal form Project Address ] start -->
    <sweet-modal blocking ref="projectAddress" class="modal">
      <h1 class="modal__title">Project Address</h1>

      <iframe width="100%" height="400px" id="gmap_canvas" :src="map" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
    </sweet-modal>
    <!-- [ Modal form Project Address ] end -->

<!--    <div class="book-mark-block pointer">-->
<!--      <div v-if="bookmarkListProject.info" @click="changeBookMarkProject(bookmarkListProject.info, $route.query.companyId, selectedRow.projectId)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--      <div v-else @click="changeBookMarkProject(bookmarkListProject.info, $route.query.companyId, selectedRow.projectId)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--    </div>-->
  </div>
</template>

<script>
  import moment from 'moment'
  // import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import axios from 'axios';
  import projectHistory from '@/components/Projects/projectHistoryTab.vue'
  // import Rate from '@/components/Projects/infoPanel/Rate.vue'
  // import Material from '@/components/Projects/estimate/material/Material.vue'

  // estimate
  // import estimateTab from '@/components/Projects/accountTHINK/estimate/estimateTab.vue'

  // projectPermissionTab
  import projectPermissionTab from '@/components/Projects/permissions/projectPermissionTab.vue'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import about from '@/components/Projects/about/about.vue'

  export default  {
    name: 'info-tab',
    beforeMount() {

    },
    mounted(){

    },
    components: {
      projectHistory,
      projectPermissionTab,
      SweetModal,
      about,
    },
    props: [
      'selectedTaskForInfo',
      'activeInfoTab',
      'value',
      'selectedRow',
      'projectInfo',
      // 'bookmarkListProject',
      'companyLayout',
      'projectPermission'
    ],
    computed: {
    },
    watch: {
      projectInfo: function (val) {
        this.projectCompanyUserList = this.projectInfo.projectCompanyUserList
        this.projectCompanyClientList = this.projectInfo.projectCompanyClientList
        this.projectCompanyVendorList = this.projectInfo.projectCompanyVendorList

        let start = this.projectInfo.startDate
        let end = this.projectInfo.deadlineDate

        if (start.toString().length < 8) {
          start = '0' + start.toString()
        } else {
          start = start.toString()
        }
        if (end.toString().length < 8) {
          end = '0' + end.toString()
        } else {
          end = end.toString()
        }

        start = moment(start, 'DDMMYYYY');
        end = moment(end, 'DDMMYYYY');

        this.plannedDaysProject = moment.duration(end.diff(start)).asDays()
      }
    },
    data() {
      return {
        map: '',
        newVendorList:[],
        newClientList:[],
        tooltipUser: {},
        plannedDaysProject: null,
        // Project
        projectCompanyUserList: null,
        projectCompanyClientList: null,
        projectCompanyVendorList: null,
        // Task
        projectTaskCompanyUserList: null,
        sharedProjectTaskTeamCompanyUserList: null,
        sharedProjectTaskCompanyUserList: null,
        tempSharedProjectTaskCompanyUserList: null,
        taskStatusStyle: null,
        moment:moment,
        taskStatusName: '',
        emtyDescription: this.$i18n.t('noDetailsProvided'),
        colors: [
          {color: '#e67112', percentage: 25},
          {color: '#63B8FF', percentage: 51},
          {color: '#63B8FF', percentage: 76},
          {color: '#0fd641 ', percentage: 100}
        ],
        // permissions
        permissionsList: [],
        pressetsList: []
      }
    },
    methods:{
      openMap() {
        let address = this.projectInfo.country.name + ',' +  this.projectInfo.state.name + ',' +  this.projectInfo.city.name
        if (this.projectInfo.address) {
          address = address + ',' + this.projectInfo.address
        }
        if (this.projectInfo.address2 > 0) {
          address = address + ',' + this.projectInfo.address2
        }
        if (this.projectInfo.address3.length > 0) {
          address = address + ',' + this.projectInfo.address3
        }
        this.map = 'https://maps.google.com/maps?q=' + address + '&t=&z=13&ie=UTF8&iwloc=&output=embed';
        this.$refs['projectAddress'].open()
      },
      getUserInfo(id){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projects/fieldInfo?companyId=${this.$route.query.companyId}&field=companyUser&companyUserId=${id}`)
                .then(response => {
                  console.log('hello2131231', response.data)
                  this.tooltipUser = response.data.fieldInfo.user
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      // changeBookMarkProject(state, companyId, projectId, taskId){
      //   // data.info = state
      //   let data = this.bookmarkListProject
      //   data.info = !this.bookmarkListProject.info
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //   axios.post(`/api/v1/bookmarks/setProject?companyId=${companyId}&projectId=${projectId}`, data)
      //           .then(response => {
      //             if (this.bookmarkListProject.info) {
      //               this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
      //             } else {
      //               this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
      //             }
      //           })
      //           .catch(error => {
      //           });
      // },
      handleClick(tab, event) {
        // history
        if(tab.name === "five"){
          this.$store.dispatch('getProjectHistory')
        }

        // if(tab.label === "Estimate"){
        //   this.$store.dispatch('getCostType')
        // }

        // if(tab.label === "Project Team"){
        //   this.getProjectTeam();
        // }
        // if(tab.label === "Task Team"){
        //   this.getTaskTeam();
        // }

        // Material
        // if(tab.label === "Material"){
        //   // this.getMaterialList();
        //
        //   this.$store.dispatch('getProjectMaterialDirectories', {id: this.$route.query.taskId, operation: 'create'})
        // }

        if(tab.name === "permissions") {

          this.$store.dispatch('getProjectPermissionsList', this.$route.query.projectId);
          this.loadPermissionData()
        }

        if(tab.name === "about"){
          this.$store.dispatch('about', 'project')
        }
      },
      async loadPermissionData(){
        try {
          this.permissionsList = await this.getPermissionsRulesList();

          this.pressetsList = await this.getPermisssionsPressetsList()
        } catch(err){
          console.log(err)
        }
      },
      getPermissionsRulesList(){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .get(`/api/v1/permissionRules/list?permissionGroup=2`)
                  .then(response => {
                    console.log('---', response.data);
                    resolve(response.data.list);
                    loader.hide()
                  })
                  .catch(error => {
                    loader.hide();
                    console.log('An error occurred:', error);
                  });
        })
      },
      getPermisssionsPressetsList(){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .get(`/api/v1/permissionPressets/list?permissionGroup=2&companyId=${this.$route.query.companyId}`)
                  .then(response => {
                    console.log('---', response.data);
                    const customPresset = {
                      companyId: 0,
                      id: 0,
                      permissionGroup: 2,
                      permissionPressetIdArr: [],
                      permissionPressetName: "customPresset"
                    };
                    response.data.list.push(customPresset);
                    resolve(response.data.list)
                    loader.hide()
                  })
                  .catch(error => {
                    loader.hide();
                    console.log('An error occurred:', error);
                  });
        })
      },
      // getMaterialList() {
      //   // this.$refs['Material'].loadList();
      //   let loader = this.$loading.show();
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //   axios
      //           .post(`/api/v1/materials/directories?companyId=${this.$route.query.companyId}&taskId=${this.$route.query.taskId}&operation=create`)
      //           .then(response => {
      //             loader.hide()
      //           })
      //           .catch(error => {
      //             loader.hide()
      //             console.log('An error occurred:', error);
      //           });
      // },
      setNewPermissions(permissions){
        this.$emit('setNewPermissions', permissions)
      }
    }
  }
</script>

<style lang="less" scoped>
  .days-block{
    margin-top:5px;
    span{
      font-weight:bold;
    }
  }
  .about-task{
    display:none;
  }
  .about-task.open{
    display:block;
  }
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    display:flex;
    align-items:center;
    font-weight:bold;
    padding:10px;
    font-size:14px;
    transition: .5s;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  .card {
    margin-bottom: 20px;
    .tag {
      margin-right: 5px;
    }
    &__no {
      display: flex;
      align-items: center;
      font-weight: bold;
      padding-bottom: 5px;
      .name {
        margin-right: 10px;
      }
      .progress {
        flex: 1;
      }
    }
    &__name {
      font-weight: bold;
      padding-bottom: 5px;
    }
    &__task-name {
      font-size: 18px;
      border-bottom: 1px solid #ccc;
      padding-bottom: 5px;
    }
    &__location {
      padding-top: 5px;
      padding-bottom: 5px;
    }
    &__stat {
      padding-top: 5px;
      padding-bottom: 5px;
      border-bottom: 1px solid #ccc;
      span {
        font-weight: bold;
      }
    }
    &__by-to {
      padding-top: 5px;
      padding-bottom: 5px;
      border-bottom: 1px solid #ccc;
      span {
        font-weight: bold;
      }
    }
    &__btn {
      // padding-top: 5px;
      // padding-bottom: 5px;
      // text-align: right;
      margin-left: 10px;
    }
  }

  .panel {
    min-width: 890px;
    margin-bottom: 20px;

    i.color {
      font-style: normal;
      color: #888;
    }

    // Header
    &__header {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #EBEEF5;
      padding-bottom: 10px;
    }

    &__project-name {
      span {font-weight: bold;}
    }
    &__task-name {
      font-weight: bold;
      font-size: 20px;
    }
    &__progress {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 5px;
      .el-progress {
        width: 350px;
      }
    }
    &__status {
      display: flex;
      justify-content: flex-end;
    }

    // Info
    &__info {
      // border-bottom: 1px solid #EBEEF5;
      padding: 10px 0 5px 0;
      position: relative;
    }
    &__date {
      display: flex;
      margin-bottom: 5px;
    }
    &__planned {
      width: 300px;
      span {font-weight: bold;}
    }
    &__actual {
      span {font-weight: bold;}
      i {font-style: normal;}
    }
    &__by-to {
      display: flex;
      margin-bottom: 5px;
    }
    &__by {
      width: 300px;
      span {font-weight: bold;}
    }
    &__to {
      span {font-weight: bold;}
    }
    &__address {

    }
    &__priority {
      position: absolute;
      top: 35%;
      right: 0;
    }

    // Description
    &__description {
      position: relative;
      // border-bottom: 1px solid #EBEEF5;
      padding: 5px 0;
    }

    &__gif {
      position: absolute;
      top: 18px;
      left: 0;
    }

    // Footer
    &__footer {
      display: flex;
      justify-content: space-between;
      min-height: 150px;
      padding: 5px 0;
    }
    &__team {
      width: calc(100%/3);
      padding: 0 10px 0 0;
      border-right: 1px solid #EBEEF5;
      &_title {
        // font-weight: bold;
        font-size: 16px;
      }
      &_item {
        cursor: pointer;
        // margin-left: 25px;
        line-height: 1.5;
        // color: #4277A6;
        color: black;
      }
    }
    &__clients {
      width: calc(100%/3);
      padding: 0 10px;
      border-right: 1px solid #EBEEF5;
      &_title {
        font-weight: bold;
      }
      &_item {
        cursor: pointer;
        margin-left: 22px;
      }
    }
    &__vendors {
      width: calc(100%/3);
      padding: 0 0 0 10px;
      &_title {
        font-weight: bold;
      }
      &_item {
        cursor: pointer;
        margin-left: 22px;
      }
    }

    &__first {
      width: 46%;
      padding: 0 10px 0 0;
      border-right: 1px solid #EBEEF5;
      &_title {
        // font-weight: bold;
        font-size: 16px;
      }
      &_item {
        cursor: pointer;
        margin-left: 25px;
        line-height: 1.5;
        color: #4277A6;
      }
    }
    &__second {
      width: 27%;
      padding: 0 10px;
      border-right: 1px solid #EBEEF5;
      &_title {
        // font-weight: bold;
        font-size: 16px;
      }
      &_item {
        cursor: pointer;
        margin-left: 25px;
        line-height: 1.5;
        color: #4277A6;
      }
    }
    &__third {
      width: 27%;
      padding: 0 0 0 10px;
      // border-right: 1px solid #EBEEF5;
      &_title {
        // font-weight: bold;
        font-size: 16px;
      }
      &_item {
        cursor: pointer;
        margin-left: 25px;
        line-height: 1.5;
        // color: #4277A6;
        color: black;
      }
    }
  }
  .pointer {
    cursor:pointer;
  }
  .vendor{
    font-weight:bold;
  }
</style>
<style lang="scss">
  .el-collapse-item__header {
    color: #888 !important;
    padding-left: 25px !important;
    font-size: 16px !important;
  }
  .el-collapse-item__content {
    color: #4277A6 !important;
    p {
      color: #4277A6 !important;
      font-size: 14px !important;
      padding-left: 25px !important;
      img {
        max-width: 100% !important;
      }
    }
  }

  .modal {
    color: #000;
    &__title {
      text-align: center;
    }
    &__btn {
      text-align: right;
    }
  }

  // [ Modal ] end
  //.tab-content{
    //position:relative;
    //.book-mark-block{
    //  position:absolute;
    //  top:0;
    //  right:0;
    //  .el-checkbox__input{
    //    display:none;
    //  }
    //  .el-checkbox {
    //    border: none;
    //  }
    //  .el-checkbox__label{
    //    font-size:20px !important;
    //    color: #409EFF;
    //  }
    //}
  //}

  .h-center {
    display: flex;
    align-items: center;
  }

  .info-title-color {
    // color: #888;
    color: black;
  }

  .info-color {
    // color: #4277A6;
    color: black;
  }
</style>

<style lang="scss">
  .el-divider--horizontal {
    margin: 14px 0 !important;
    background-color: #EBEEF5 !important;
  }

  p {
    img {
      max-width: 100%;
    }
  }
  .title {
    color: #409EFF;
    font-weight: 500;
    text-decoration: underline;
    margin-bottom: 5px;
    text-transform: uppercase;
  }
</style>
